import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { BookWizard } from '../components/wizard';

export default function NewBookPage() {
  const navigate = useNavigate();
  const { bookId } = useParams<{ bookId?: string }>();
  const location = useLocation();

  // Determine initial step from URL path
  const getInitialStep = (): number => {
    if (location.pathname.endsWith('/storyteller')) return 3;
    if (location.pathname.endsWith('/description')) return 2;
    // Both /books/new and /books/new/:id/basics are step 1
    return 1;
  };

  const handleComplete = (completedBookId: string) => {
    // After wizard completion, go to book page
    navigate(`/books/${completedBookId}`);
  };

  const handleCancel = () => {
    navigate('/books');
  };

  const handleStepChange = (step: number, newBookId?: string) => {
    const id = newBookId || bookId;
    if (step === 1) {
      // If we have a book ID, navigate to basics with ID, otherwise just /books/new
      if (id) {
        navigate(`/books/new/${id}/basics`, { replace: true });
      } else {
        navigate('/books/new', { replace: true });
      }
    } else if (step === 2 && id) {
      navigate(`/books/new/${id}/description`, { replace: true });
    } else if (step === 3 && id) {
      navigate(`/books/new/${id}/storyteller`, { replace: true });
    }
  };

  return (
    <BookWizard
      onComplete={handleComplete}
      onCancel={handleCancel}
      initialStep={getInitialStep()}
      bookId={bookId}
      onStepChange={handleStepChange}
    />
  );
}
